module.exports = __webpack_public_path__ + "img/cart.520c4168.svg";